import { applyMiddleware, createStore } from "redux";
import { composeWithDevTools } from "redux-devtools-extension";
import persistState from "redux-localstorage";
import thunk from "redux-thunk";

import isRouteToSales from "app/helpers/is/isRouteToSales";
import { APP_DATA_SOURCE_LOCAL_STORAGE_KEY } from "app/pages/app-intelligence/common-components/app-solution-toggle/constants";
import siMiddlewares from "app/pages/sales-intelligence/store/middlewares";
import { mainReducer } from "app/reducers/main";
import { cleanDigitalSuiteFiltersLocalStorage } from "app/routes/handlers/filter-consistency/filterConsistencyUtils";

import { setStore } from "./store";
import thunkDependencies from "./thunk-dependencies";

export const generateStore = () => {
    cleanDigitalSuiteFiltersLocalStorage();

    let middlewares = [thunk.withExtraArgument(thunkDependencies)];

    if (isRouteToSales()) {
        middlewares = [...siMiddlewares, ...middlewares];
    }

    const navOverrideLocalStorage = persistState("primaryNavOverride", {
        key: "primaryNavOverride",
    });
    const appIntelligenceDataSourceLocalStorage = persistState("appDataSource", {
        key: APP_DATA_SOURCE_LOCAL_STORAGE_KEY,
    });
    const solution25OptInLocalStorage = persistState("solutions25", {
        key: "solutions25",
    });
    const userFiltersSelectionLocalStorage = persistState("usersFiltersSelection", {
        key: "usersFiltersSelection",
    });
    const userDigitalSuiteFiltersSelectionLocalStorage = persistState("usersDigitalSuiteFiltersSelection", {
        key: "usersDigitalSuiteFiltersSelection",
    });
    const projectWizardLocalStorage = persistState("projectWizard", {
        key: "projectWizard",
    });

    const composeEnhancers = composeWithDevTools({
        // Specify name here, actionsBlacklist, actionsCreators and other options if needed
    });
    const initialState = {};

    const newStore = createStore(
        mainReducer,
        initialState,
        composeEnhancers(
            applyMiddleware(...middlewares),
            navOverrideLocalStorage,
            appIntelligenceDataSourceLocalStorage,
            solution25OptInLocalStorage,
            userFiltersSelectionLocalStorage,
            userDigitalSuiteFiltersSelectionLocalStorage,
            projectWizardLocalStorage,
        ),
    );
    setStore(newStore);
    return newStore;
};
